import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '3rem',
      maxWidth: '758px',
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: '0 1rem',
      gap: '0.5rem',
    },
    column: {
      maxWidth: '758px',
      width: '100%',
    },
    fieldsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      flexGrow: 1,
      width: '100%',
      alignItems: 'center',
      marginBottom: '8rem',
    },
  })
);
